import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { PublisherCollectingSocietyViewStore } from "../../store";
import { PublisherCollectingSocietyView } from "./PublisherCollectingSocietyView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type PublisherCollectingSocietyDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const PublisherCollectingSocietyDrawerContent: React.FC<PublisherCollectingSocietyDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new PublisherCollectingSocietyViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <PublisherCollectingSocietyView
        publisherCollectingSocietyViewStore={viewStore}
      />
    );
  });
